/**
 * Route access: sidebar menu items plus known child pages of those items.
 * Keep SIDEBAR_CHILD_PATHS in sync when adding create/edit/detail screens.
 */

export const SIDEBAR_CHILD_PATHS = {
    'housekeeping-request': ['accepted-task'],
    'properties-list': ['properties-create', 'properties-edit'],
    'ownership-list': ['ownership-create', 'ownership-edit'],
    'manage-requests': [
        'create-mapping',
        'mapping-edit',
        'room-item-mapper',
        'room-item',
        'room-task'
    ],
    'multi-property-monitor': ['reservation-profile'],
    'reservation-report': ['reservation-profile']
};

/** Operational paths that are not sidebar items but every authenticated user may need. */
export const ALWAYS_ALLOW_PREFIXES = [
    'change-property',
    'dashboard',
    // Legacy Room Status Monitor URL → redirects to multi-property-monitor
    'monitor',
    'tasks-process',
    'page-error-400',
    'page-error-403',
    'page-error-404',
    'page-error-500',
    'page-error-503',
    'page-lock-screen',
    'callback'
];

export function normalizeAppPath(pathname) {
    return String(pathname || '')
        .replace(/^\/+/, '')
        .replace(/\/+$/, '');
}

function pathMatchesPrefix(pathname, prefix) {
    const path = normalizeAppPath(pathname);
    const pre = normalizeAppPath(prefix);
    if (!pre) return !path;
    return path === pre || path.startsWith(`${pre}/`);
}

export function collectMenuTos(items) {
    const tos = [];
    if (!Array.isArray(items)) return tos;
    for (const item of items) {
        if (item?.to) {
            tos.push(normalizeAppPath(item.to));
        }
        if (Array.isArray(item?.content)) {
            tos.push(...collectMenuTos(item.content));
        }
    }
    return tos;
}

export function canAccessPath(pathname, menuItems) {
    const path = normalizeAppPath(pathname);
    if (!path) return true;

    if (ALWAYS_ALLOW_PREFIXES.some((prefix) => pathMatchesPrefix(path, prefix))) {
        return true;
    }

    const menuTos = collectMenuTos(menuItems);
    if (menuTos.some((to) => pathMatchesPrefix(path, to))) {
        return true;
    }

    for (const [parent, children] of Object.entries(SIDEBAR_CHILD_PATHS)) {
        if (!menuTos.some((to) => to === normalizeAppPath(parent))) {
            continue;
        }
        if (children.some((child) => pathMatchesPrefix(path, child))) {
            return true;
        }
    }

    return false;
}

export function getDefaultHomePath(menuItems, roleName) {
    const isRoomops = roleName && String(roleName).toLowerCase().includes('roomops');
    if (isRoomops) {
        return '/multi-property-monitor';
    }
    const first = collectMenuTos(menuItems)[0];
    return first ? `/${first}` : '/dashboard';
}
